import envconstants from './envconstants';
export const apiDetails = {   

     USE_LOCAL_TOKEN: true,

     // COMMON
     AUTH_HOST: envconstants.appURL,
     HOST_NAME: envconstants.backendURL,
     
     //Context
     CONTEXT: 'v2/',

     GENERATE_TOKEN: 'authorization/token/',

     //DEVICE APIS
     DEVICE_LIST: 'device/list',
     DEVICE_CREATE: 'device/create',
     DEVICE_UPDATE: 'device/edit',
     DEVICE_DELETE: 'device/delete',
     DEVICE_VIEW: 'device/view',
     DEVICE_PING: 'device/ping',
     DEVICE_PROFILE_CREATE: 'device-profile/create',
     FETCH_DEVICE_TAG_LIST: 'device/assetTagging/fetchTaggedAsset',
     FETCH_DEVICE_UN_TAG_LIST: 'device/assetTagging/fetchUntaggedAssets',
     ADD_TAG_ASSET: 'device/assetTagging/addTagAsset',
     DELETE_TAG_ASSET: 'device/assetTagging/deleteTaggedAsset',
     RIGHT_PANEL: 'hierarchy/list',

     // ALARMA APIs
     ALARM_LIST: 'alarm/list',
     ALARM_HISTORY_LIST: 'alarmHistory/list',
     ALARM_HISTORY_DETAIL_LIST: 'alarmHistory',
     ALARM_UPDATE_STATE: 'alarm/stateChange',

     // Asset
     ASSET_TYPES: 'asset/types',
     ASSET_VIEW: 'asset/view',

     // Users
     USER_ROLES: 'user/roles/list'

    
}